import Base from './Base';
import HubspotAttachment from '../models/HubspotAttachment';

export default class HubspotAttachments extends Base {
    get models() {
        const collection = this.data.map(item => new HubspotAttachment(item));
        collection.collection = this;

        return collection;
    }
}
